module.exports = __webpack_public_path__ + "img/freestyle_box29.dcb2a5e2.jpg";